import { i18n } from 'i18n';

export type NewBreakingSchedulePageParams = Readonly<Record<'pourId', string | undefined>>;

export const POUR_PARAM_IDENTIFIER = ':pourId';
export const ROUTE_PATH = `/qaqc/${POUR_PARAM_IDENTIFIER}/breaking-schedules/new`;
export const TITLE = i18n._('Create New Breaking Schedule');
